import * as types from "../actions/types";


const initialState = {
    isOpen: false,
    isUploading: false,
    queue: [],
    inProgress: [],
    done: [],
    progress: null
};


export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case types.UPDATE_UPLOAD_PROGRESS:
            return Object.assign({}, state, {
                progress: action.progress
            });

        case types.CLOSE_UPLOAD_MANAGER:
            return Object.assign({}, state, {
                isOpen: false,
                queue: [],
                done: [],
                inProgress: []
            });

        case types.OPEN_UPLOAD_MANAGER:
            return Object.assign({}, state, {
                isOpen: true
            });

        case types.PUT_FILE_IN_PROGRESS:
            return Object.assign({}, state, {
                inProgress: action.file
            });

        case types.PUT_FILES_IN_QUEUE:
            return Object.assign({}, state, {
                queue: action.files
            });

        case types.PUT_FILE_IN_DONE:
            const done = state.done;
            done.push(action.file);
            return Object.assign({}, state, {
                done: done
            });

        default:
            return state;
    }
};
